export const ERRORS = {
  GET_PRODUCTS: 'Cannot get products from shopify!',
  GET_METADATA: 'Cannot get meta data from shopify!'
}

export const ERROR_OBJ = {
  msg: '',
  state: false
}
